import { api } from './client'

// User-scoped mutations outside the auth flow.
export const usersApi = {
  // Opt the current user in or out of research data use. Idempotent —
  // back-to-back flips land on the latest value. Returns the consent
  // snapshot { research_consent, consent_version, consented_at }.
  setConsent: (researchConsent, token) =>
    api.patch('/users/consent', { research_consent: researchConsent }, token),

  // AI data-sharing consent (Anthropic). Distinct from research consent;
  // the backend gates every AI call on it, effective immediately.
  // Returns { ai_data_consent, ai_consent_version, ai_consented_at }.
  setAIConsent: (aiConsent, token) =>
    api.patch('/users/ai-consent', { ai_data_consent: aiConsent }, token),
}
